import React, { useState } from "react";
import './expandableContent.css'

function ExpandableContent({children, title = "Expandable"}) {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div className="Expandable">
            <div className="ContentTitle" onClick={toggleExpand}>
                <h2>{title}</h2>
                <h2>{isExpanded ? '▲' : '▼'}</h2>
            </div>
            {isExpanded && (
                <div className="ExpandableContent">
                    {children}
                </div>
            )}
        </div>
    );
}

export default ExpandableContent;